import { render, staticRenderFns } from "./update_internal_info.vue?vue&type=template&id=7bbd71eb"
import script from "./update_internal_info.vue?vue&type=script&lang=js"
export * from "./update_internal_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports